import styles from "./SolidSelect.module.css";
import { forwardRef } from "react";
import PropTypes from "prop-types";

/**
 * Dropdown selector with a solid background suitable for
 * display on top of bright colors with varying contrast.
 */
export const SolidSelect = forwardRef((props, ref) => {
  const { name, value, onChange, children } = props;

  return (
    <div className={styles.selector}>
      <select
        ref={ref}
        name={name}
        value={value}
        onChange={onChange}
        className={styles.input}
      >
        {children}
      </select>
      <span className={styles.indicator} />
    </div>
  );
});

SolidSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};
